/* eslint-disable no-unused-expressions */
import { useQuery } from '@apollo/client';
import { COLORS } from 'constants/globalVariable';
import isEmpty from 'lodash/isEmpty';
import React, { lazy, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import GETSCHOOLBYID from './getSchoolsById';
import actionNoticeBoard from 'redux/noticeBoard/action';
import getCode from 'utils/getRoleCode';

const List = lazy(() => import('common/access/List'));
const CategoryDetail = lazy(() => import('common/access/CategoryDetail'));
const ContentDetail = lazy(() => import('common/access/ContentDetail'));
const NotFound = lazy(() => import('views/NotFound'));

const Layout = lazy(() => import('layouts/antd/Layout'));
const Home = lazy(() => import('views/pages/home/Home'));
const Analytic = lazy(() => import('views/pages/analytic'));
const SchoolDistributionMap = lazy(() =>
  import('views/pages/schoolDistributionMap')
);
const Popup = lazy(() => import('views/pages/popup'));

const Login = lazy(() => import('views/login/Login'));

const LayoutContainer = () => (
  <Layout>
    <Switch>
      <Route component={Home} exact path='/' />
      <Route component={Home} exact path='/home' />
      <Route component={Analytic} exact path='/analytic' />
      <Route
        component={SchoolDistributionMap}
        exact
        path='/school-distribution-map'
      />
      <Route component={Popup} exact path='/popup' />
      <Route
        component={CategoryDetail}
        path='/:type/:name/detail-category/:identifier'
      />
      <Route
        component={ContentDetail}
        path='/:type/:name/detail-content/:identifier'
      />
      <Route component={List} path='/:type/:name' />
      <Route component={NotFound} path='*' />
    </Switch>
  </Layout>
);

const FrontAndLayoutContainer = () => (
  <Switch>
    <Route component={Login} exact path='/login' />
    <Route component={LayoutContainer} path='/' />
  </Switch>
);

const RouteHandler = () => {
  const [dataColor, setDataColor] = useState({});
  const profile = useSelector((state) => state.profile);

  // Check if current user is Supervisor
  const isSupervisor = profile?.role?.role_code === getCode('Supervisor');

  useQuery(GETSCHOOLBYID, {
    variables: {
      id: profile?.school?.id,
    },
    // Skip query if profile school id is empty OR if user is Supervisor
    skip: isEmpty(profile?.school?.id) || isSupervisor,
    onCompleted: (data) => {
      setDataColor(data);
      actionNoticeBoard.setNoticeBoard(data?.schoolById?.short_description);
    },
    onError: (err) => console.error(err),
  });

  useEffect(() => {
    const root = document?.documentElement;

    // For Supervisor, use default colors without hitting GraphQL
    if (isSupervisor) {
      root?.style.setProperty('--secondary-color', COLORS.secondaryColor);
      return;
    }

    // For other roles, use colors from GraphQL data
    if (!isEmpty(dataColor?.schoolById?.secondary_color)) {
      root?.style.setProperty(
        '--secondary-color',
        dataColor?.schoolById?.secondary_color
      );
    } else {
      root?.style.setProperty('--secondary-color', COLORS.secondaryColor);
    }
  }, [dataColor, isSupervisor]);

  return (
    <BrowserRouter>
      <Route component={FrontAndLayoutContainer} path='/' />
      <Route path='/' />
    </BrowserRouter>
  );
};

export default RouteHandler;
